import React from 'react';
import { IoMdRefresh } from 'react-icons/io';

interface FilterResetButtonProps {
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  rotation: string;
}

export const FilterResetButton: React.FC<FilterResetButtonProps> = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  rotation,
}) => {
  return (
    <button
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-tooltip-content={'Réinitialiser les filtres'}
      data-tooltip-id="tooltip"
      data-tooltip-place={'bottom'}
      data-tooltip-delay-show={100}
      data-tooltip-offset={0}
      className="rounded-full p-1.5 text-gray-500 transition-all duration-200 hover:bg-gray-100 hover:text-primary dark:text-gray-400 dark:hover:bg-gray-800"
    >
      <IoMdRefresh
        className="text-xl transition-all duration-500"
        style={{ transform: rotation }}
      />
    </button>
  );
};
